/* Under Contact Form 7 plugin */

const stepForm = {
    stepFormWrapper: document.querySelectorAll('.custom-step-form'),

    fileUploadProgress(el) {
        const files = el.querySelectorAll('input[type="file"]');
        [...files].forEach((elem, ind) => {
            elem.addEventListener('change', () => {
                const fakeButton = elem.parentNode.nextElementSibling;
                fakeButton.textContent = "UPLOAD SUCCESSFUL!";
                elem.parentNode.parentNode.classList.add('changed');
            });
        });
    },
    buttonControlTrigger(el, prev) {
        var text;
        if (prev) {
            text = 'back';
        } else {
            text = 'next';
        }

        const btn = el.querySelectorAll(`.btn-custom-form-${text}`);
        const form = el;
        [...btn].forEach((element, ind) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                const activeEl = form.querySelector('.displayed-step');
                activeEl.classList.remove('displayed-step');
                if (prev) {
                    activeEl.previousElementSibling.classList.add('displayed-step');
                } else {
                    activeEl.nextElementSibling.classList.add('displayed-step');
                }
            });
        });
    },
    wrappSelects(el){
        const selects = el.querySelectorAll('select');
        if( selects ){
            [...selects].forEach( (item, ind ) =>{
                const p = item.parentNode;
                if( p ){
                    p.classList.add('select-wrapper');
                }
            });
        }
    },

    init() {
        if (this.stepFormWrapper) {
            [...this.stepFormWrapper].forEach((el, ind) => {
                this.buttonControlTrigger(el, true);
                this.buttonControlTrigger(el, false);
                this.fileUploadProgress(el);
                this.wrappSelects(el);
            });
        }
    }
}

export default stepForm;
